(function (aimi_mdcdot_lead_api, $, app, undefined) {

  app.apis['mdcdot_lead']  = function () {
    return {
      save: function (requestData) {
        return app.postRequest(`/api/mdcdot/lead`, requestData, function () {
        }, function () {
        }, '');
      },
      update: function (requestData) {
        return app.putRequest(`/api/mdcdot/lead`, requestData, function () {
        }, function () {
        }, '');
      }
    }
  }();

  app.apis['mdcdot'] = function () {
    return {
      leads: {
        'list': function (url, sortBy, sortByDirection, searchParams ) {

          if (!app.isEmpty(sortBy)) {
            url = Utils.addParamToURL(url, {'sortField': sortBy});
          }

          if (!app.isEmpty(sortByDirection)) {
            url = Utils.addParamToURL(url, {'sortDirection': sortByDirection});
          }

          if (!app.isEmpty(searchParams)) {
            url = Utils.appendQueryString(url, Utils.jsonToQueryString(searchParams));
          }

          return app.getRequest(url, {}, function () {
          }, function () {
          }, '');
        },

        'add': function (requestData) {
          return app.postRequest(`/api/mdcdot/leads`, requestData, function () {
          }, function () {
          }, '');
        },

        'get': function (id) {
          return app.getRequest(`/api/mdcdot/lead/${id}`, {}, function () {
          }, function () {
          }, '');
        },

        'campaign': function (requestData) {
          return app.postRequest(`/api/mdcdot/dot/campaign`, requestData, function () {
          }, function () {
          }, '');
        },

        'delete': function (requestData) {
          return app.deleteRequest(`/api/mdcdot/lead`, requestData, function () {
          }, function () {
          }, '');
        },

        unsubscribe: function (requestData) {
          return app.postRequest(`/api/mdcdot/lead/unsubscribe`, requestData, function () {
          }, function () {
          }, '');
        },
      },
      campaignLead : {
        list: function () {
          return app.getRequest(`/api/mdcdot/dot/campaign`, {}, function () {
          }, function () {
          }, '');
        }
      },
      tags: {
        list: function () {
          return app.getRequest(`/api/mdcdot/tags`, {}, function () {
          }, function () {
          }, '');
        },
        save: function (requestData) {
          return app.postRequest(`/api/mdcdot/tags`, requestData, function () {
          }, function () {
          }, '');
        }
      },

      stages: {
        list: function () {
          return app.getRequest(`/api/mdcdot/stages`, {}, function () {
          }, function () {
          }, '');
        }
      },

      campaignMultiple: async function (requestData) {
        if (!app.isEmpty(requestData.ids)) {
          requestData.ids = Utils.uniqueTags(requestData.ids);
          requestData.ids = requestData.ids.join(',');
          return this.leads.campaign(requestData);
        } else {
          return {};
        }
      },


      tagMultiple: async function (requestData) {
        let results = [];

        if (!app.isEmpty(requestData.addTags)) {
          requestData.addTags = Utils.uniqueTags(requestData.addTags);
        }
        if (!app.isEmpty(requestData.removeTags)) {
          requestData.removeTags = Utils.uniqueTags(requestData.removeTags);
        }

        if (!app.isEmpty(requestData.ids)) {
          requestData.ids = Utils.uniqueTags(requestData.ids);
          requestData.ids = requestData.ids.join(',');
          results = await this.tags.save(requestData);
        } else {
          return {};
        }
        return results;
      }


    }
  }();

}(window.aimi_mdcdot_lead_api = window.aimi_mdcdot_lead_api || {}, jQuery, PreBuilt));
